import { FC, ReactNode } from 'react';

import { useIntl } from 'react-intl';

import styles from './step-menu.module.scss';

import { Button } from 'views/components/UI/Button';
import { ArrowLeft } from 'views/components/UI/Icons/Icons';
import { Menu } from 'views/components/UI/Menu';

interface IStepMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  title: ReactNode;
  onBack?: () => void;
  busy?: boolean;
  children: ReactNode;
}

// A two-step composition of Menu; overlay, dismissal and focus remain kit-owned.
const StepMenu: FC<IStepMenuProps> = ({
  anchorEl,
  onClose,
  title,
  onBack,
  busy,
  children,
}) => {
  const intl = useIntl();
  return (
    <Menu
      anchorEl={anchorEl}
      onClose={onClose}
      mode="content"
      appearance="inset"
      itemAppearance="option"
      size="medium"
      busy={busy}
      title={
        <span className={styles.heading}>
          {onBack && (
            <Button
              mode="tertiary"
              color="dark"
              icon={<ArrowLeft />}
              onClick={onBack}
              disabled={busy}
              aria-label={intl.formatMessage({ id: 'common.back' })}
            />
          )}
          <span title={typeof title === 'string' ? title : undefined}>{title}</span>
        </span>
      }
    >
      {children}
    </Menu>
  );
};

export { StepMenu };
